import api from '@/apis/gl/gLVoucherListAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('chooseVoucherReportGLVoucherSummaryTable', api);

const state = {
  ...crud.state,
  _config: {
    table: 'gl_voucher_list',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  async customDelete(context, payload) {
    let res = null;
    payload = payload || {};
    try {
      context.commit('updateLoading', true);
      res = await api.customDelete(payload);
      let errValidate = ['VALIDATE', 'Business', 'Exception', 'GENERATE_DATA'];
      let keyField = context.state._config.field.key;
      //Danh sách gửi lên xóa
      let deleted = [...payload.Models];
      if (keyField && res) {
        for (let i = 0; i < res.length; i++) {
          // Nếu không xóa được thì loại bỏ khỏi list xóa
          if (errValidate.find(x => x === res[i]?.Code)) {
            if (res[i] && res[i].Data && res[i].Data.Data) {
              let itemError = payload.Models[res[i].Index];
              //Loại đi những bản ghi không xóa được
              deleted = deleted.filter((item, index) => {
                return !(item[keyField] === res[i].Data.Data[keyField] || item[keyField] === itemError[keyField]);
              });
            }
          }
        }
      }
      //Commit thực hiện xóa
      context.commit('deleteItems', deleted);
    } finally {
      context.commit('updateLoading', false);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
